import request from '@/utils/request'
export async function getNews () {
    return await request.post('/api/zxAnnouncement/guanwangQueryAllByLimit')
}

// getNews().then(res => {
//     console.log(res)
// })